import { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { LANDING_PAGES } from "models";
import { usePermanentSession } from "modules/Login/hooks";
import { sessionBroadcastChannel } from "router/components";
import { REDIRECT_HANDLER_URL } from "router/hooks";
import { PATHS } from "router/paths";

const LandingPageMapping = new Map([
  [LANDING_PAGES.Main, PATHS.APPOINTMENTS],
  [LANDING_PAGES.LeadDashboard, PATHS.LEADS_DASHBOARD],
  [LANDING_PAGES.WarrantyDashboard, PATHS.WARRANTY_DASHBOARD],
  [LANDING_PAGES.ManufacturerDashboard, PATHS.MANUFACTURER_DASHBOARD],
  [LANDING_PAGES.DayplannerDashboard, PATHS.DAYPLANNER],
  [LANDING_PAGES.ExactMonitoringDashboard, PATHS.EXACT_MONITORING]
]);

export const useRedirectToLandingPage = (redirectAutoOnSessionSet?: boolean) => {
  const history = useHistory();
  const { session } = usePermanentSession();

  const redirectToLandingPage = async (broadcastSession?: boolean) => {
    if (broadcastSession) sessionBroadcastChannel.postMessage({ type: "LOGIN", session });

    let redirectUrlHandler = localStorage.getItem(REDIRECT_HANDLER_URL);
    if (redirectUrlHandler) localStorage.removeItem(REDIRECT_HANDLER_URL);

    const redirectQRCode = session?.appointment_id;
    if (redirectQRCode) redirectUrlHandler = PATHS.APPOINTMENT_DETAIL.replace(":id", redirectQRCode.toString());

    if (redirectUrlHandler) return history.push(redirectUrlHandler, { from: PATHS.LOGIN });

    if (!session?.landing_page_id) return history.push(PATHS.HOME);

    const landingPagePath = LandingPageMapping.get(session.landing_page_id);
    return history.push(landingPagePath ?? PATHS.APPOINTMENTS);
  };

  useEffect(() => {
    if (session?.token && redirectAutoOnSessionSet) redirectToLandingPage(redirectAutoOnSessionSet);
  }, [session?.token]);

  return redirectToLandingPage;
};
